// CANONICAL COPY (GH #7115). src/constants/obligations/obl-pentest-external.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-pentest-external',
  title: 'Perform external penetration test',
  description:
    'Schedule and execute an external penetration test with a qualified third party at least annually and after any significant infrastructure or application change. Testing shall cover both network and application layers. Findings shall be documented, risk-ranked, and remediated within defined timelines; exploitable and high-risk findings shall be retested to confirm resolution.',
  category: 'technical',
  scfIds: ['SCF-AUD-001', 'SCF-AUD-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Penetration test report or programme document is published',
    },
    { type: 'document-within-sla', description: 'Penetration test is not overdue' },
    {
      type: 'manual-attestation',
      description: 'Confirm the external penetration test was actually performed',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
